export const getConfidenceTexts = (confidence) => {
  switch (confidence) {
    case "high":
      return {
        title: "High volume",
        description: "There are high chances of finding this load with listed rates",
      };
    case "medium":
      return {
        title: "Medium volume",
        description: "There are fair chances of finding this load with listed rates",
      };
    case "low":
      return {
        title: "Low volume",
        description: "There might be chances of finding this load with listed rates",
      };
    default:
      return {
        title: "Unknown volume",
        description: "Insufficient data to predict market availability for this load",
      };
  }
};

export const getPredictionConfidenceTexts = (confidence) => {
  switch (confidence) {
    case "high":
      return {
        title: "High volume",
        description: "There are solid chances of finding this load at predicted rates",
      };
    case "medium":
      return {
        title: "Medium volume",
        description: "There are fair chances of finding this load at predicted rates",
      };
    case "low":
      return {
        title: "Low volume",
        description: "There might be chances of finding this load at predicted rates",
      };
    default:
      return {
        title: "Unknown volume",
        description: "Insufficient data to predict market availability for this load",
      };
  }
};
